import React, {useContext, useEffect, useState} from 'react';
import './AiAgentsPage.scss';
import Layout from "../../modules/Layout/Layout";
import {Text} from "../../modules";
import {ArrowLeftIcon, PlusIcon} from "../../image";
import {Select, Switch} from "antd";
import ModalAgent from "./components/ModalAgent/ModalAgent";
import EmptyState from "./EmptyFon.png";
import {
    GetAgentsService,
    GetTemplatesAgentsService,
    UpdateAgentService,
    UpdateLanguageAgentService
} from "../../redux/actions/agentActions";
import {useDispatch, useSelector} from "react-redux";
import ChatBlock from "../../shared/chat/ChatBlock";
import {isCheckAuth} from "../../utils/helperFunctions";
import {useTranslation} from "react-i18next";
import {CheckTokenService} from "../../redux/actions";
import {ROUTERS_MAP} from "../../utils/routes";
import {useHistory, useLocation} from "react-router-dom";
import {Loader} from "../../shared/features/Loader";
import {STEPS} from "../../modules/Tour/helpers";
import TourSixStep from "../../modules/Tour/components/TourSixStep/TourSixStep";

const AiAgentsPage = () => {
    const [isVisibleModal, setIsVisibleModal] = useState(false);
    const dispatch = useDispatch();
    const templatesList = useSelector(state => state.agents.templatesList || []);
    const agentsList = useSelector(state => state.agents.agentsInfo?.agents || []);
    const agentsInfo = useSelector(state => state.agents.agentsInfo);
    const language = useSelector(state => state.agents.language);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const activeStep = useSelector((state) => state.tour?.activeStep);

    const isAuth = isCheckAuth();
    const {t} = useTranslation();
    const urlParams = new URLSearchParams(location.search);
    const paramsAgentId = urlParams.get('agentId');

    const [selectedId, setSelectedId] = useState();
    const [agentSelectedId, setAgentSelectedId] = useState();
    const [loadingSwitch, setLoadingSwitch] = useState(null);

    useEffect(()=>{
        if(paramsAgentId){
            setSelectedId(null);
            setAgentSelectedId(Number(paramsAgentId));
            setIsVisibleModal(true);
            urlParams.delete('agentId');
        }
    },[])

    const getContent = async () => {
        try {
            setLoading(true);
            dispatch(GetAgentsService());
            dispatch(GetTemplatesAgentsService(language));
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    }

    useEffect(() => {
        isCheckToken();
        getContent();
    }, [])

    const switchAgent = async (agent) => {
        try {
            setLoadingSwitch(agent?.id);
            await UpdateAgentService(agent?.id, {is_active: !agent?.is_active});
            dispatch(GetAgentsService());
        } catch (e) {
            console.error(e)
        }finally {
            setTimeout(()=>setLoadingSwitch(null),500)
        }
    }

    const isCheckToken = async () => {
        try {
            const response = await dispatch(CheckTokenService());
            if (response.status !== 200) {
                history.push(ROUTERS_MAP.LOGIN)
            }
        } catch (e) {
            history.push(ROUTERS_MAP.LOGIN)
            console.error(e)
        }
    }

    return (
        <Layout isSearch title={t('agents_title')}>
            <div className="ai-agents-wrap">
                <div className={`ai-agents chat-anchor`}>
                    {loading ?
                        <div className="ai-agents__loader">
                            <Loader size={120}/>
                        </div>
                        :
                        <>
                            <div className="ai-agents__container">
                                <div className="ai-agents__block" style={{height: activeStep === STEPS.SIX ? 208 : 240}}>
                                    <div className="ai-agents__block--sub-title">
                                        <Text size="f20" font="medium"
                                              className="ai-agents__block-subtitle">{t('templates')}</Text>
                                        <Select
                                            disabled={activeStep === STEPS.SIX}
                                            suffixIcon={<ArrowLeftIcon/>}
                                            value={language}
                                            onChange={(value) => {
                                                dispatch(GetTemplatesAgentsService(value))
                                                dispatch(UpdateLanguageAgentService(value))
                                            }}
                                            options={[
                                                {value: 'english', label: 'EN'},
                                                {value: 'russian', label: 'RUS'}
                                            ]}
                                        />
                                    </div>
                                    <div className="ai-agents__list custom-scroll">
                                        {templatesList.map((template) => (
                                            <div
                                                id={`template-id-${template?.id}`}
                                                className="ai-agents__agent" onClick={() => {
                                                if(activeStep !== STEPS.SIX){
                                                    setSelectedId(template?.id);
                                                    setAgentSelectedId(null);
                                                    setIsVisibleModal(true);
                                                }
                                            }}>
                                                <Text size="f16" font="book"
                                                      className="ai-agents__agent-title">{template.name}</Text>
                                                <div className="ai-agents__agent-block">
                                                    <Text size="f12" font="book"
                                                          color="#9898A6">{template.description}</Text>
                                                    <div className="ai-agents__agent-block--icon-wrap  plus-wrap">
                                                        <PlusIcon/>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="ai-agents__block   template-list">
                                    <div className="ai-agents__block--sub-title">
                                        <Text size="f20" font="medium" className="ai-agents__block-subtitle">
                                            {t('connected_agents')}
                                            <Text size="f20" font="medium" color="#CDCDCD">
                                                {" "}({agentsInfo?.agents_on || 0}/{agentsInfo?.agents_total || 0})
                                            </Text>
                                        </Text>
                                    </div>
                                    {!agentsList.length ?
                                        <div className="ai-agents__empty custom-scroll">
                                            <Text font="medium" size="f20"
                                                  color="#9898A6">{t('no_connected_agents')}</Text>
                                            <img src={EmptyState}/>
                                        </div>
                                        :
                                        <div className="ai-agents__list custom-scroll">
                                            {agentsList.map((agent) => (
                                                <div className="ai-agents__agent" onClick={() => {
                                                    setAgentSelectedId(agent?.id);
                                                    setSelectedId(null);
                                                    setIsVisibleModal(true)
                                                }}>
                                                    <Text size="f16" font="book"
                                                          className="ai-agents__agent-title">{agent?.name}</Text>
                                                    <div className="ai-agents__agent-block">
                                                        <Text size="f12" font="book"
                                                              color="#9898A6">{agent?.description}</Text>
                                                        <div className="ai-agents__agent-block--icon-wrap">
                                                            <Switch
                                                                loading={loadingSwitch === agent?.id}
                                                                onClick={(e, event) => event.stopPropagation()}
                                                                checked={agent?.is_active}
                                                                onChange={() => switchAgent(agent)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            <ModalAgent
                templateId={selectedId}
                agentId={agentSelectedId}
                show={isVisibleModal}
                onClose={() => setIsVisibleModal(false)}
            />
            {isAuth ? <ChatBlock/> : null}
            <TourSixStep
                openTemplateModal={(id)=>{
                    setSelectedId(id);
                    setAgentSelectedId(null);
                    setIsVisibleModal(true);
                }}
            />

        </Layout>
    );
};

export default AiAgentsPage;